import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import style from './Layouts.module.scss'
import LayoutsButton from './LayoutsButton'
import LayoutsMenu from './LayoutsMenu'
import { setLayout, setMediaType } from '../../dataStore/actions/room/room'
import { LayoutType } from '../../dataStore/slices/layouts/layoutsSlice'
import { State } from '../../dataStore/reducers/reducerType'
import { mediaType as MediaType } from '@bt-react/constants'
import { setAutoSpotlight } from '../../dataStore/actions/room/room'
import { LayoutsSlice } from '../../dataStore/slices/layouts'
import { SeatingOrderParticipant } from '../../dataStore/reducers/docs/syncSeatingOrder/types'

const Layouts: FC = () => {
  const activePresenterLayoutType = useSelector((state: State) => state.layouts.presenterLayout.layoutType) as LayoutType
  const activeMediaLayoutType = useSelector((state: State) => state.layouts.mediaLayout.mediaLayoutType) as LayoutType
  const currentLayouts = useSelector((state: State) => state.layouts) as LayoutsSlice
  const currentMediaType = useSelector((state: State) => state.room.mediaType) as MediaType
  const presenterCountFromSeatingOrder = useSelector((state: State) => state.syncSeatingOrder.seatingOrder) as Record<string, SeatingOrderParticipant>
  const [layoutsMenuToggle, setLayoutsMenuToggle] = useState(false)
  const [presenterActiveLayout, setPresenterActiveLayout] = useState(LayoutType.Gallery)
  const [mediaActiveLayout, setMediaActiveLayout] = useState(LayoutType.Full)
  const featureFlags = useSelector((state: State) => state.config.featureFlags)
  const dispatch = useDispatch<any>()

  useEffect(() => {

    if (Object.keys(presenterCountFromSeatingOrder).length < 2 && currentMediaType === MediaType.SPOTLIGHT) {

      dispatch(setAutoSpotlight(false))

    }

    if (currentMediaType === MediaType.WEBCAM) setPresenterActiveLayout(LayoutType.Gallery)
    else setPresenterActiveLayout(activePresenterLayoutType)
    setMediaActiveLayout(activeMediaLayoutType)

  }, [presenterCountFromSeatingOrder, currentMediaType, dispatch, activePresenterLayoutType, activeMediaLayoutType])

  const layoutsBtnClick = () => setLayoutsMenuToggle(!layoutsMenuToggle)
  const layoutsMenuBlur = () => setLayoutsMenuToggle(false)

  const layoutsMenuItemClick = (type: LayoutType) => {

    setLayoutsMenuToggle(!layoutsMenuToggle)
    setPresenterActiveLayout(type)

    dispatch(setLayout({
      ...currentLayouts,
      presenterLayout: {
        presenterLayoutsActive: type === LayoutType.Gallery ? false : true,
        sidebarActive: type === LayoutType.Gallery ? currentLayouts.presenterLayout.sidebarActive : type === LayoutType.Full ? false : true,
        layoutType: type === LayoutType.Gallery ? currentLayouts.presenterLayout.layoutType : type
      }
    }))

    if (type === LayoutType.Split && !currentLayouts.presenterLayout.presenterLayoutsActive) {
      dispatch(setAutoSpotlight(true))
    }

    if (type === LayoutType.Gallery && currentMediaType === MediaType.SPOTLIGHT) {
      dispatch(setMediaType(MediaType.WEBCAM))
      dispatch(setAutoSpotlight(false))
    }

    if ((type === LayoutType.Sidebar || type === LayoutType.Full)) {
      dispatch(setMediaType(MediaType.SPOTLIGHT))
      currentMediaType === MediaType.WEBCAM && dispatch(setAutoSpotlight(true))
    }

  }

  const layoutsMediaMenuItemClick = (type: LayoutType) => {

    setLayoutsMenuToggle(!layoutsMenuToggle)
    setMediaActiveLayout(type)

    dispatch(setLayout({
      ...currentLayouts,
      mediaLayout: {
        mediaSidebarActive: type === LayoutType.Sidebar || type === LayoutType.Split ? true : false,
        mediaLayoutType: type
      }
    }))

  }

  return featureFlags.layouts ? (
    <div
      tabIndex={1}
      data-bdd={'layouts-container'}
      className={style['layouts']}
      onBlur={layoutsMenuBlur}
    >
      <LayoutsButton
        layoutsMenuOpen={layoutsMenuToggle}
        activeLayoutType={currentMediaType === MediaType.WEBCAM || currentMediaType === MediaType.SPOTLIGHT ?
          presenterActiveLayout : mediaActiveLayout}
        layoutsBtnClick={layoutsBtnClick}
      />
      <LayoutsMenu
        layoutsMenuOpen={layoutsMenuToggle}
        activeLayoutType={currentMediaType === MediaType.WEBCAM || currentMediaType === MediaType.SPOTLIGHT ?
          presenterActiveLayout : mediaActiveLayout}
        layoutsMenuItemClick={currentMediaType === MediaType.WEBCAM || currentMediaType === MediaType.SPOTLIGHT ?
          layoutsMenuItemClick : layoutsMediaMenuItemClick}
        mediaType={currentMediaType}
      />
    </div>
  ) : null
}

export default Layouts
